"use client";
import Oops from "@/../assets/images/Oops.svg";
import { Colors } from "@/enums/Colors";
import { Box, Typography, styled } from "@mui/material";

import CommonButton from "@/components/utils/CommonButton";
import { useTranslation } from "react-i18next";

const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: "1.5rem",
  fontWeight: 500,
  lineHeight: "1.8rem",
  textAlign: "center",
  color: Colors.BLACK_151517,
}));

const StyledBody = styled(Typography)(({ theme }) => ({
  fontSize: "1.125rem",
  fontWeight: 500,
  lineHeight: "1.35rem",
  textAlign: "center",
  color: Colors.BLACK_151517,
}));

interface Props {
  goBack: () => void;
}

export function ErrorComponent(props: Props) {
  const { t } = useTranslation("common");

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        alignContent: "center",
        gap: 1,
      }}
    >
      <img src={Oops.src} />

      <Box
        sx={{
          paddingTop: "2rem",
          display: "flex",
          flexDirection: "column",
          gap: "0.5rem",
        }}
      >
        <StyledTitle>{t("errorPage.title")}</StyledTitle>
        <StyledBody>{t("errorPage.description")}</StyledBody>
      </Box>

      <Box sx={{ paddingTop: "2rem" }}>
        <CommonButton sx={{ width: "5.6525rem", height: "2.75rem" }} onClick={() => props.goBack()}>
          <Typography>{t("goBack")}</Typography>
        </CommonButton>
      </Box>
    </div>
  );
}
